<template lang="pug">
  .b-show-more
    .b-btn._btn(@click="onClick") {{ btnLabel }}
</template>

<script>
export default {
  name: 'BaseShowMore',
  props: {
    label: String,
    loading: Boolean,
  },
  computed: {
    btnLabel() {
      if (this.loading) {
        return 'Загрузка...';
      }

      return this.label || 'Загрузить еще';
    },
  },
  methods: {
    onClick() {
      if (!this.loading) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.show-more {
  display: grid;
  align-items: center;
  position: relative;
  grid-template-columns: 1fr auto 1fr;
  gap: 22px;
  &:before,
  &:after {
    content: "";
    display: inline-block;
    width: 100%;
    height: 2px;
    transform: translateY(-50%);
    background-color: #d1d9f0;
    box-shadow: inset 0 -1px 0 var(--color-white);
  }
  &__btn {
    z-index: 5;
  }
}
</style>
